/**
 * Brazilian Portuguese (pt-BR) mappings for AuthPromptModal
 */

export const authPromptModalPtBR = {
  // Modal header
  "AUTHENTICATION REQUIRED": "AUTENTICAÇÃO NECESSÁRIA",

  // Default messages
  "Sign in to continue": "Entre para continuar",
  "Create a free account to access this feature": "Crie uma conta gratuita para acessar este recurso",

  // Feature-specific messages
  "Start chatting with AI": "Comece a conversar com IA",
  "Sign in to get personalized sports insights and predictions": "Entre para obter insights e previsões esportivas personalizadas",

  "View your history": "Veja seu histórico",
  "Sign in to access your conversation history and saved predictions": "Entre para acessar seu histórico de conversas e previsões salvas",

  "Access live sports data": "Acesse dados esportivos ao vivo",
  "Sign in to get real-time sports updates and analytics": "Entre para obter atualizações esportivas e análises em tempo real",

  "Get AI predictions": "Obtenha previsões de IA",
  "Sign in to receive AI-powered game predictions and analysis": "Entre para receber previsões e análises de jogos geradas por IA",

  "Manage Star Coins": "Gerencie Star Coins",
  "Sign in to view and use your Star Coins balance": "Entre para ver e usar seu saldo de Star Coins",

  "Sign in to Analyze Insights": "Entre para Analisar Insights",
  "Join thousands of users getting AI-powered sports insights": "Junte-se a milhares de usuários obtendo insights esportivos com IA",

  // Buttons
  "Continue with Google": "Continuar com Google",
  "Already have an account? Sign in": "Já tem uma conta? Entre",

  // Divider
  "or": "ou",

  // Security
  "Secured by Google": "Protegido pelo Google",

  // Benefits section
  "No Risk, No Catches": "Sem Risco, Sem Pegadinhas",
  "100% FREE — forever": "100% GRÁTIS — para sempre",
  "Zero credit card required": "Zero cartão de crédito necessário",
  "Upgrade only if you want more power": "Atualize apenas se quiser mais poder"
};
